import { api } from './client';

export interface RolePermissionDto {
  id: number;
  module: string;
  canView: boolean;
  canAdd: boolean;
  canEdit: boolean;
  canDelete: boolean;
}

export interface UserRoleDto {
  id: number;
  roleName: string;
  description: string | null;
  isSystem: boolean;
  permissions: RolePermissionDto[];
}

export interface CreateRoleRequest {
  roleName: string;
  description?: string;
  permissions: Array<{
    module: string;
    canView: boolean;
    canAdd: boolean;
    canEdit: boolean;
    canDelete: boolean;
  }>;
}

export interface UpdateRoleRequest {
  roleName: string;
  description?: string;
  permissions: Array<{
    module: string;
    canView: boolean;
    canAdd: boolean;
    canEdit: boolean;
    canDelete: boolean;
  }>;
}

export const rolesApi = {
  list: () =>
    api.get<UserRoleDto[]>('/roles'),

  getById: (id: number) =>
    api.get<UserRoleDto>(`/roles/${id}`),

  create: (data: CreateRoleRequest) =>
    api.post<number>('/roles', data),

  update: (id: number, data: UpdateRoleRequest) =>
    api.put<void>(`/roles/${id}`, data),

  delete: (id: number) =>
    api.delete<void>(`/roles/${id}`),
};
